import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App";
import { env } from "./lib/env";
import { initXPixel } from "./lib/xPixel";
import { initGa4 } from "./lib/ga4";
import "./styles/global.css";

// No-ops safely when VITE_SENTRY_DSN is unset (local dev).
Sentry.init({ dsn: env.VITE_SENTRY_DSN, environment: import.meta.env.MODE, tracesSampleRate: 0 });
// No-ops safely when VITE_X_PIXEL_ID is unset (local dev, or before the pixel's been created).
initXPixel();
// No-ops safely when VITE_GA4_MEASUREMENT_ID is unset (local dev).
initGa4();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
